export default __webpack_public_path__ + "6481047ae0a229f0258faa4f9598bfc8.png";